
export class HolidayDateReq {
    holidayDate: any
    constructor(
        holidayDate: any
    ) {
        this.holidayDate = holidayDate
    }

}